import { Link, useLocation } from "wouter";
import { Menu, X, Phone } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { cn } from "@/lib/utils";
import craneFullLogo from "@assets/crane-logo-6E7QMWbM-removebg-preview_1774122076170.png";

const links = [
  { href: "/", label: "Home" },
  { href: "/products", label: "Products" },
  { href: "/industries", label: "Industries" },
  { href: "/services", label: "Services" },
  { href: "/about", label: "About Us" },
  { href: "/careers", label: "Careers" },
  { href: "/contact", label: "Contact" },
];

export function Navbar() {
  const [location] = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80 border-b border-border shadow-sm">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between">
        <Link href="/">
          <img src={craneFullLogo} alt="Crane Consumables" width="1960" height="580" className="h-16 w-auto cursor-pointer" data-testid="link-home-logo" />
        </Link>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {links.map((link) => (
            <Link key={link.href} href={link.href}>
              <span
                data-testid={`link-nav-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={cn(
                "text-sm font-medium transition-colors hover:text-primary cursor-pointer tracking-wide",
                location === link.href ? "text-primary font-bold border-b-2 border-primary" : "text-muted-foreground"
              )}>
                {link.label}
              </span>
            </Link>
          ))}
          <Button size="sm" className="ml-4 font-bold tracking-wider" asChild>
            <Link href="/contact" data-testid="button-get-quote">Get a Quote</Link>
          </Button>
        </div>

        {/* Mobile Nav */}
        <div className="lg:hidden">
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" data-testid="button-mobile-menu">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[300px] sm:w-[400px]">
              <div className="flex flex-col gap-6 mt-10">
                {links.map((link) => (
                  <Link key={link.href} href={link.href} onClick={() => setIsOpen(false)}>
                    <span className={cn(
                      "text-lg font-medium transition-colors hover:text-primary cursor-pointer block py-2 border-b border-border/50",
                      location === link.href ? "text-primary font-bold" : "text-foreground"
                    )}>
                      {link.label}
                    </span>
                  </Link>
                ))}
                <div className="mt-4 p-4 bg-muted rounded-md">
                  <p className="text-sm font-medium text-muted-foreground mb-2">Need immediate assistance?</p>
                  <a href="tel:+15135399980" className="flex items-center gap-2 text-primary font-bold">
                    <Phone className="w-4 h-4" /> (513) 539-9980
                  </a>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}
